<div class="col-md-12 u-mt20" *ngIf="!selectedPersonData">
  <div class="box u-mb60">
    <div class="row">
      <div class="col-lg-8">
        <app-select-list title="Buscar conductor" hintText="*El rut debe ser sin puntos y con guión"
          placeHolder="Buscar por nombre, rut* o email" (textInputValueEmitter)="onSearchPersonTextChange($event)"
          [optionList]="listPersonOptions" (selectedValueEmitter)="onSearchPersonSelected($event)"
          [isLoading]="loadingPersonOptions"
        >

        </app-select-list>
      </div>
      <div class="col-lg-3 offset-lg-1">
        <button type="button" class="btn btn--primary btn--big u-mt20" (click)="onSelectPerson()"
          [ngClass]="personForm.controls.id.value > 0 ? '' : 'btn--disabled'">Buscar conductor</button>
      </div>
    </div>
  </div>
</div>
<div class="col-md-12 u-mb60" *ngIf="!!selectedPersonData">
  <div class="row" style="margin-top: 20px;">
    <div class="col-md-12">
      <h2 class="txt txt--section">
        1. Información personal
      </h2>
    </div>
  </div>
  <app-person-card [personData]="selectedPersonData">
  </app-person-card>
  <span class="back back--small u-mt10 global-hand" (click)="onUnselect()">
    Buscar otra persona
  </span>
</div>
